module.exports = __webpack_public_path__ + "img/stack08.3f781f95.svg";